var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevelop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2694 18.9347C32.3262 8.40915 47.6738 8.40914 48.7306 18.9347C49.2539 24.1476 54.2037 27.7419 59.3258 26.6285C69.6681 24.3804 74.4107 38.9691 64.7216 43.2262C59.9229 45.3345 58.0323 51.1502 60.6746 55.675C66.0097 64.8111 53.5932 73.8275 46.5482 65.9329C43.0591 62.0231 36.9409 62.0231 33.4518 65.9329C26.4068 73.8275 13.9903 64.8111 19.3254 55.675C21.9677 51.1502 20.0771 45.3345 15.2784 43.2262C5.58926 38.9691 10.3319 24.3804 20.6742 26.6285C25.7963 27.7419 30.7461 24.1476 31.2694 18.9347Z",
    fill: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelop);
export default __webpack_public_path__ + "static/media/develop.165be7a6df03dd8290b48a630964a506.svg";
export { ForwardRef as ReactComponent };